var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar navbar-fixed-top", attrs: { role: "navigation" } },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "navbar-header" }, [
          _c(
            "a",
            { staticClass: "navbar-brand", attrs: { href: _vm.logoLink } },
            [_c("div", { staticClass: "logo" })]
          ),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "nav-item center" }, [
          _c("li", { class: _vm.active === "home" ? "active" : "" }, [
            _c("a", { attrs: { href: _vm.homeLink } }, [_vm._v("Home")]),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
        ]),
        _vm._v(" "),
        _vm._m(2),
      ]),
      _vm._v(" "),
      _vm.dialogShown
        ? [
            _c(
              "div",
              {
                staticClass: "layui-layer-shade",
                attrs: { id: "layui-layer-shade1", times: "1" },
              },
              [
                _c("div", { staticClass: "content" }, [
                  _c("img", { attrs: { src: "/img/pink-alert.png" } }),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "btn",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function ($event) {
                        return _vm.toOnelink()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        t: "1670470464455",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "3468",
                        width: "200",
                        height: "200",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M649.179 512l212.839-212.84c37.881-37.881 37.881-99.298 0-137.179s-99.298-37.881-137.179 0L512 374.821l-212.839-212.84c-37.881-37.881-99.298-37.881-137.179 0s-37.881 99.298 0 137.179L374.821 512 161.982 724.84c-37.881 37.881-37.881 99.297 0 137.179 18.94 18.94 43.765 28.41 68.589 28.41 24.825 0 49.649-9.47 68.589-28.41L512 649.179l212.839 212.84c18.94 18.94 43.765 28.41 68.589 28.41s49.649-9.47 68.59-28.41c37.881-37.882 37.881-99.298 0-137.179L649.179 512z",
                          "p-id": "3469",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}",
          },
        },
        [_vm._v("Live")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}",
          },
        },
        [
          _c("i", { staticClass: "hot" }),
          _vm._v("\n            Hot\n          "),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "nav-item last" }, [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://app.appsflyer.com/com.mico?pid=flatads_int&af_siteid=${AF_SITEID}&af_click_lookback=7d&clickid=${AUCTION_BID_ID}&advertising_id=${GAID}",
            },
          },
          [
            _c("i", { staticClass: "app-icon" }),
            _vm._v(" "),
            _c("span", [_vm._v("App")]),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }